__turbopack_context__.v({
  "carouselWrapper": "Ra_U2q_carouselWrapper",
  "root": "Ra_U2q_root",
});
